import constantes from '../helpers/constanteHelper';
import { retornarTexto } from '../helpers/textoHelper'

import TituloNegrito from './TituloNegrito';

function Videos({ item, resolucaoMobile, idioma }) {
    return (
        <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <TituloNegrito texto={retornarTexto(idioma, 'videos')} />
            <div className='mb-5 animate__animated animate__fadeIn d-flex flex-wrap align-items-center justify-content-center' style={{ gap: '30px' }}>
                {item['Vídeos'].map((video) => <div style={{ gap: '15px' }} className='mb-5 animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center'>
                    <span className='mt-2' style={{ width: resolucaoMobile ? '300px' : '350px', height: '130px', fontSize: resolucaoMobile ? '16px' : '19px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO }}>{video['Título do vídeo']}</span>
                    <div >
                        <iframe
                            width={resolucaoMobile ? '280' : '853'}
                            height={resolucaoMobile ? '157.56' : '480'}
                            src={`https://www.youtube.com/embed/${video['Código do vídeo']}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded youtube"
                        />
                    </div>
                </div>)}
            </div>
        </div>
    );
}
export default Videos;
